/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description track signup
 */

import { SIGNUP, event } from '@zcode/integrations'
import { localStorageSingleton } from '@zcode/nr-utils'
import { SIGNUP_TENANT_TYPE } from '../constants'

const trackSignup =
  ({ origin, user }) =>
  (dispatch) => {
    const campaign = localStorageSingleton.getx('_campaign')
    const referrer = localStorageSingleton.getx('_referrer')
    const traffic = localStorageSingleton.getx('_traffic')
    const props = { campaign, origin, referrer, traffic, userType: SIGNUP_TENANT_TYPE }
    dispatch(event({ name: SIGNUP, props, user }))
  }

export default trackSignup
